<template>
    <div class="cadre">
        <h3>Stocks</h3>
        <table>
            <thead>
                <tr>
                    <th>Categorie</th>
                    <th>Zone Stockage</th>
                    <th>Total</th>
                    <th>
                        <div class="tab_outils">
                            <div>
                                <a data-bs-toggle="modal" data-bs-target="#modalTransfertStock">
                                    <i class="material-icons"
                                        style="font-size:20px;color:aliceblue; display: flex;justify-content: flex-end">repeat</i>
                                </a>
                            </div>
                            <div>
                                <a data-bs-toggle="modal" data-bs-target="#modalEditStock" v-on:click="editStock(null)">
                                    <i class="material-icons"
                                        style="font-size:20px;color:black; display: flex;justify-content: flex-end">add_circle</i>
                                </a>
                            </div>
                        </div>
                    </th>
                </tr>

            </thead>
            <tbody>
                <tr v-for="(stock, index) in stocks" :key="stock.id"
                    :class="{ 'selected-row': selectedStockId === stock.id }">
                    <td>{{ stock.categorie.libelle }}</td>
                    <td>{{ stock.zoneStockage.libelle }}</td>
                    <td>{{ stock.total }}</td>
                    <td>
                        <div class="tab_outils">
                            <div>
                                <a v-on:click="viewStock(stock.id)">
                                    <i class="material-icons"
                                        style="font-size:20px;color: cornflowerblue">visibility</i>
                                </a>
                            </div>

                            <div>
                                <a data-bs-toggle="modal" data-bs-target="#modalEditStock"
                                    v-on:click="editStock(stock.id)">
                                    <i class="material-icons" style="font-size:20px;color:black">edit</i>
                                </a>
                            </div>
                            <div>
                                <a v-on:click="archiveStock(index)">
                                    <i class="material-icons" style="font-size:20px;color:gold">folder</i>

                                </a>
                            </div>
                            <div>
                                <a v-on:click="deleteStock(index)">
                                    <i class="material-icons" style="font-size:20px;color:red">delete</i>

                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td></td>
                    <td></td>
                    <td>{{ totalStocks }}</td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>
    <br />
    <div v-if="selectedStockId" class="mouvement-stocks-section">
        <div class="cadre">
            <div class="h3_remove">
                <h3>Mouvement de stocks</h3>
                <a>
                    <i class="material-icons" style="font-size:20px;color:black" @click="closeListeStock">close</i>
                </a>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Quantité</th>
                        <th>Traitement</th>
                        <th>Date</th>
                        <th>Fournisseur</th>
                        <th>
                            <div class="tab_outils">
                                <div>
                                    <a data-bs-toggle="modal" data-bs-target="#modalEditMouvementStock"
                                        v-on:click="editMouvementStock(null)">
                                        <i class="material-icons"
                                            style="font-size:20px;color:black; display: flex;justify-content: flex-end">add_circle</i>
                                    </a>
                                </div>
                            </div>
                        </th>
                    </tr>

                </thead>
                <tbody v-if="mouvementStocks && mouvementStocks.length">
                    <tr v-for="(mouvementStock, index) in paginatedItems" :key="mouvementStock.id">
                        <td>{{ mouvementStock.quantite }}</td>
                        <td :style="mouvementStock.typeTraitement == 'IN' ? 'color:green' : 'color:red'">{{
                            mouvementStock.typeTraitement }}</td>
                        <td>{{ this.format(mouvementStock.date) }}</td>
                        <td><span v-if="mouvementStock.fournisseur">{{ mouvementStock.fournisseur.libelle }}</span></td>
                        <td>
                            <div class="tab_outils">
                                <div>
                                    <a data-bs-toggle="modal" data-bs-target="#modalEditMouvementStock"
                                        v-on:click="editMouvementStock(mouvementStock.id)">
                                        <i class="material-icons" style="font-size:20px;color:black">edit</i>
                                    </a>
                                </div>
                                <div>
                                    <a v-on:click="deleteMouvementStock(index)">
                                        <i class="material-icons" style="font-size:20px;color:red">delete</i>
                                    </a>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot v-else>
                    <tr>
                        <td colspan="5" class="emptyTableMessage">Aucun mouvement de stock trouvé</td>
                    </tr>
                </tfoot>
            </table>
            <div class="pagination">

                <a v-on:click="previousPage()" :disabled="currentPage === 1">
                    <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_left</i>
                </a>
                <span>Page {{ currentPage }} sur {{ totalPages }}</span>
                <a v-on:click="nextPage()" :disabled="currentPage === totalPages">
                    <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_right</i>
                </a>
            </div>
        </div>
    </div>

    <StockEdit :params="{ id: stockEditId }" @saved="fetchStocks"/>
    <MouvementStockEdit :params="{ id: mouvementStockEditId, idStock: selectedStockId }" @saved="fetchStocks();viewStock(selectedStockId)"/>
    <StockTransfert @saved="fetchStocks"/>

</template>

<script>
import Axios from '@/services/axios.service';
import DateFormatService from '@/services/dateFormat.service';
import PaginationService from '@/services/pagination.service';

import MouvementStockEdit from '../mouvementStock/MouvementStockEdit.vue';
import StockEdit from './StockEdit.vue';
import StockTransfert from './StockTransfert.vue';

export default {
    name: 'StockIndex',
    mixins: [PaginationService, DateFormatService],
    components: {
        StockEdit,
        MouvementStockEdit,
        StockTransfert
    },
    data() {
        return {
            stocks: [],
            mouvementStocks: null,
            selectedStockId: null,

            stockEditId: null,
            mouvementStockEditId: null,
        };
    },
    props: {
        msg: String
    },
    mounted() {
        this.fetchStocks();
    },
    methods: {
        fetchStocks() {
            Axios.get('/stock/statut/ACTIF')
                .then(res => {
                    this.stocks = res.data;
                })
                .catch(err => {
                    console.error('Erreur lors du chargement des stocks :', err);
                });
        },

        //Gestion Stock
        deleteStock(index) {
            Axios.delete('/stock/' + this.stocks[index].id)
                .then(response => {
                    if (response.status == 200) {
                        this.stocks.splice(index, 1)
                    }
                }).catch(err => {
                    console.error('Erreur lors de la suppression du stock :', err);
                });
        },
        editStock(id) {
            this.stockEditId = id;
        },
        archiveStock(index) {
            Axios.post('/stock/' + this.stocks[index].id)
                .then(response => {
                    if (response.status == 201) {
                        this.stocks.splice(index, 1)
                    }
                }).catch(err => {
                    console.error('Erreur lors de l archivage du stock :', err);
                });
        },

        //Affichage Stock par stock
        viewStock(id) {
            this.selectedStockId = id;
            Axios.get(`/mouvementStock/stock/${id}`)
                .then((res) => {
                    this.items = res.data
                    this.mouvementStocks = res.data
                }).catch(err => {
                    console.error('Erreur lors du chargement des mouvements de stocks :', err);
                });
        },
        closeListeStock() {
            this.mouvementStockEditId = null;
            this.selectedStockId = null;
        },

        //Gestion mouvement des stocks
        deleteMouvementStock(index) {
            Axios.delete('/mouvementStock/' + this.stocks[index].id)
                .then(response => {
                    if (response.status == 200) {
                        this.stocks.splice(index, 1)
                    }
                })
                .catch(err => {
                    console.error('Erreur lors de la suppression du mouvement de stock :', err);
                });
        },
        editMouvementStock(id) {
            this.mouvementStockEditId = id;
        },
    },
    computed: {
        totalStocks() {
            return this.stocks.reduce((sum, stock) => sum + Number(stock.total), 0);
        }
    },
}
</script>

<style scoped>
.emptyTableMessage {
    text-align: center;
    color: red
}

.selected-row {
    background-color: #578FCA;
}
</style>
